/**
 * MOCK MODE — liga/desliga o modo offline com fixtures.
 *
 * Ligado por PADRÃO. Para usar a API NestJS real, defina `VITE_MOCK=false`
 * (ou `0`) no `.env`. Qualquer outro valor (ou ausência) mantém o mock ativo,
 * de forma que NENHUMA tela do admin quebra sem a API.
 *
 * Consumido por:
 *   - src/providers/dataProvider.ts  (getList/getOne/update/custom contra fixtures)
 *   - src/providers/authProvider.ts  (admin fake já logado)
 */
const raw = import.meta.env.VITE_MOCK as string | undefined;

export const MOCK_ENABLED: boolean = raw === undefined || !/^(false|0|off|no)$/i.test(raw);
